(ns frontend.view.grid.screening.view
  (:require
   [common.attribute :as attribute]
   [common.fields.table-column-widths :as widths]
   [common.localization :as loc]
   [common.schema.registry :as registry]
   [frontend.db :as app-db]
   [frontend.page-components.default-page-layout :as default-page-layout]
   [frontend.page-components.zap-toolbar :as zap-toolbar]
   [frontend.react.virtualized.scrollable-grid.common :as grid]
   [frontend.react.virtualized.scrollable-grid.components :as grid-components]
   [frontend.react.virtualized.scrollable-grid.view :as scrollable-grid]
   [frontend.react.virtualized.utils :as vu]
   [frontend.routing :as routing]
   [frontend.state.current-session :as session]
   [frontend.utils :as fu]
   [frontend.view.components.grid-filters.view :as grid-filters]
   [frontend.view.grid.common.components :as components]
   [frontend.view.grid.common.no-results-view :as no-results-view]
   [frontend.view.grid.screening.db :as db]
   [frontend.view.grid.screening.events :as events]
   [frontend.view.grid.screening.subs :as grid-subs]
   [frontend.view.named-view.events :as named-view-events]
   [frontend.view.not-found :as not-found]
   [potpuri.core :as potpuri]
   [re-frame.core :as rf]
   [reagent.core :as r]
   [ui.components.loading-spinner.view :as loading-spinner]
   [ui.components.modal.view :as new-modal-component]
   [ui.data.view-entities.event :as view-entities-event]
   [ui.data.view-entities.sub :as view-entities-sub]
   [ui.view.screening.sub :as screening-sub]
   [ui.view.screening.screening-profile-info-table.view :as screening-profile-info-table]))

(defonce select-width 30)

(defn column
  [args]
  (let [{:keys [label short-label attribute field-schema filter-data sorting-disabled? width
                hover-atom recompute-grid-sizes! flex-grow]}
        args
        default-width (-> (widths/get-column-width attribute)
                          :default-width
                          (or widths/default-width))]
    {:label               label
     :data-key            attribute
     :short-label         short-label
     :field-schema        field-schema
     :filter-data         filter-data
     :update-filter!      (fn [k filter-data]
                            (grid/set-filter (events/setup-args) k filter-data))
     :sort-disabled?      (boolean sorting-disabled?)
     :min-width           (-> (widths/get-column-width attribute)
                              :min-width
                              (or widths/min-width))
     :max-width           (-> (widths/get-column-width attribute)
                              :max-width
                              (or widths/max-width))
     :default-width       default-width
     :width               (or width default-width)
     :set-width           width
     :begin-width-update! (partial grid/begin-width-update! hover-atom attribute)
     :update-width!
     (partial grid/update-width! (events/setup-args) recompute-grid-sizes! hover-atom attribute)
     :end-width-update!   (partial grid/end-width-update! hover-atom attribute)
     :get-styling         (partial grid/get-styling hover-atom attribute)
     :flex-grow           flex-grow}))

(defn toolbar-actions
  [{:keys []}]
  [])

(defn toolbar-buttons-renderer
  []
  [:div])

(defn create-props-atom
  [selected screening-profiles filters grid-store
   recompute-grid-sizes! hover-atom _modal-atom]
  (let [tenant-schema @session/tenant-schema
        columns
        (vec (keep (fn [k]
                     (let [field-schema (registry/get-field-schema tenant-schema k)
                           label (attribute/attribute-label tenant-schema k)]
                       (column {:label                 label
                                :short-label           (attribute/short-label tenant-schema k)
                                :attribute             k
                                :field-schema          field-schema
                                :filter-data           (get filters k)
                                :sorting-disabled?     false
                                :width                 (grid/get-saved-width (events/setup-args) k)
                                :hover-atom            hover-atom
                                :recompute-grid-sizes! recompute-grid-sizes!
                                :flex-grow             1})))
                   (events/resolve-column-keys)))
        editable-grid? false]
    (r/atom
     {:grid-store              grid-store
      :setup-args              (events/setup-args)
      :selected                selected
      :link-to-entity-field    :fund/name
      :header-height           50
      :editable-grid?          editable-grid?
      :select-width            select-width
      :min-columns-width       50
      :height                  (- (or (:height @app-db/window) 400)
                                  75)                      ;; TODO: lazy - fixed 120px for button row in this view
      :avail-height            (- (or (:height @app-db/window) 400)
                                  75)                      ;; TODO: lazy - fixed 120px for button row in this view
      :useDynamicRowHeight     false                       ;; TODO: kebab-case
      :row-height              40                          ;(fn [index] 40)
      :row-count               (if (sequential? screening-profiles) (count screening-profiles) 0)
      :scrollToIndex           0
      :columns                 columns
      :overscan-count          1
       ; Override default no rows renderer because user cannot create new screening profiles here
      :no-rows-renderer        (fn []
                                 (r/as-element
                                  [:div.grid-no-rows
                                   (cond
                                     (not (:loaded @db/screening-profiles))
                                     (loc/tr :grid-loading-data)

                                     (seq (:grid-entities @db/screening-profiles))
                                     [no-results-view/no-entities-found-view]

                                     :else
                                     [:div.text-center.py-5
                                      [:img.img-fluid.mb-3.max-width {:src "/img/no-result-found.svg"}]
                                      [:strong.d-block.text-color--dark.title-h3.mb-3
                                       (loc/tr :grid-no-entities-yet)]])]))
      :on-row-click!           (fn [row]
                                 (let [data (when (< row (count screening-profiles))
                                              (nth screening-profiles row))]
                                   (rf/dispatch [::events/open-modal (:db/id data)])
                                   #_(swap! modal-atom assoc
                                            :open? true
                                            :selected (:db/id data))
                                   #_(routing/open-entity (:db/id data))))
      :on-cell-click           (fn [row col]
                                 (grid/handle-cell-click! {:columns              columns
                                                           :col                  col
                                                           :row                  row
                                                           :sorted-grid-entities screening-profiles
                                                           :state                hover-atom}))
      :is-sorted-by?           (partial grid/is-sorted-by db/view-settings)
      :is-secondary-sorted-by? (partial grid/is-secondary-sorted-by db/view-settings)
      :sort-by!                (fn [k dir]
                                 (grid/set-sort-by (events/setup-args) k dir))
      :reorder-columns!        (fn [dragged-column after-column]
                                 (grid/reorder-columns! (events/setup-args)
                                                        dragged-column
                                                        after-column))
      :can-filter?             (fn [_k]
                                 true)
      :resizing-column         (some-> @hover-atom
                                       (get :resize-start-width)
                                       (first)
                                       (key))
      :recompute-grid-sizes!   recompute-grid-sizes!
      :all-selection!          (fn []
                                 (let [selected (:selected @db/screening-profiles)]
                                   (if (or (= :all selected) (seq selected))
                                     (grid/clear-selection! (events/setup-args))
                                     (swap! db/screening-profiles assoc :selected :all))))
      :select-action-renderer  toolbar-buttons-renderer
      :on-row-select!          (fn [index checked]
                                 (let [data (when (< index (count screening-profiles))
                                              (nth screening-profiles index))
                                       kyc-profile-id (:db/id data)]
                                   (if (= selected :all)
                                     (grid/select-all-but (events/setup-args) kyc-profile-id)
                                     (if (boolean checked)
                                       (swap! db/screening-profiles assoc-in
                                              [:selected kyc-profile-id]
                                              true)
                                       (swap! db/screening-profiles potpuri/dissoc-in
                                              [:selected kyc-profile-id])))))
      :row-data-getter         (r/partial grid/default-row-data-getter screening-profiles selected)})))

(def sub-title
  {:style {:font-size   "18px"
           :font-weight 600}})

(defn get-sanction-str
  [sanction-status]
  (case sanction-status
    :sanction-status/green "Green"
    :sanction-status/yellow "Yellow"
    :sanction-status/red "Red"
    ""))

(defn get-risk-screen-url
  [external-screening-id]
  (str "https://batch.riskscreen.com/entity/view/" external-screening-id "?pageindex=0&rowsperpage=100"))

(def modal-view-id [:screening :modal])
(def modal-scope-id :entity-scope)
(def modal-instance-id :screening-list-modal)

(def new-modal*
  (r/create-class
   {:component-did-mount
    (fn [this]
      (let [selected (:selected (r/props this))]
        (when (int? selected)
          (rf/dispatch [::view-entities-event/open-view-entity-scope
                        {:view-id modal-view-id
                         :scope-id modal-scope-id
                         :entity-id selected
                         :instance-id modal-instance-id}]))))
    :component-did-update
    (fn [this [_ old-props]]
      (let [new-props (r/props this)
            old-selected (:selected old-props)
            new-selected (:selected new-props)]
        (when (not= old-selected new-selected)
          (when (int? old-selected)
            (rf/dispatch [::view-entities-event/close-view-entity-scope
                          {:view-id modal-view-id
                           :scope-id modal-scope-id
                           :entity-id old-selected
                           :instance-id modal-instance-id}]))
          (when (int? new-selected)
            (rf/dispatch [::view-entities-event/open-view-entity-scope
                          {:view-id modal-view-id
                           :scope-id modal-scope-id
                           :entity-id new-selected
                           :instance-id modal-instance-id}])))))
    :component-will-unmount
    (fn [this]
      (let [selected (:selected (r/props this))]
        (when (int? selected)
          (rf/dispatch [::view-entities-event/close-view-entity-scope
                        {:view-id modal-view-id
                         :scope-id modal-scope-id
                         :entity-id selected
                         :instance-id modal-instance-id}]))))
    :reagent-render
    (fn [{:keys [hide! selected]}]
      (let [screening-profile @(rf/subscribe [::view-entities-sub/scope-root-entity modal-view-id modal-scope-id])
            {:keys [loading? error]} @(rf/subscribe [::view-entities-sub/scope-status modal-view-id modal-scope-id])
            ;; Read the entities of this modal's own scope, like the NEV does. The
            ;; global session does not have the profile's KYC profiles on the new grid.
            kyc-profiles-and-pep-statuses @(rf/subscribe [::screening-sub/kyc-profiles-and-pep-statuses selected modal-view-id modal-scope-id])
            counterparty-diligences-and-pep-statuses @(rf/subscribe [::screening-sub/counterparty-diligences-and-pep-statuses selected modal-view-id modal-scope-id])
            pep-or-rca-mismatch-data @(rf/subscribe [::screening-sub/pep-or-rca-mismatch-data selected modal-view-id modal-scope-id])
            counterparty-diligence-access? (session/counterparty-diligence-admin?)]
        [new-modal-component/view
         {:visible? true
          :hide!    hide!}
         [:p (loc/tr :entity.type/screening-profile)]
         (cond
           screening-profile
           [:div
            {:class "flex flex-col items-center overflow-scroll"}
            [screening-profile-info-table/view
             {:screening-profile                        screening-profile
              :show-kyc-data?                           true
              :show-counterparty-diligence-data?        counterparty-diligence-access?
              :pep-or-rca-mismatch-data                 pep-or-rca-mismatch-data
              :kyc-profiles-and-pep-statuses            kyc-profiles-and-pep-statuses
              :counterparty-diligences-and-pep-statuses counterparty-diligences-and-pep-statuses}]]

           loading?
           [:div {:class "p-6 text-base-light-text-paler flex items-center gap-2"}
            [loading-spinner/circle]
            [:span (loc/tr :loading)]]

           (some? error)
           [:div {:class "p-6 text-red-600"}
            [:p "Unable to load screening profile data."]
            [:p {:class "mt-2 text-sm text-base-light-text-paler"} (str error)]]

           :else
           [:div {:class "p-6 text-base-light-text-paler flex items-center gap-2"}
            [loading-spinner/circle]
            [:span (loc/tr :loading)]])]))}))

(defn new-modal
  [props]
  [new-modal* props])

(defn render
  [grid-store _kanban-feature?]
  (let [hover-atom (r/atom {:hover {:col nil :row nil}})

        modal-atom (r/atom {:open?    false
                            :selected nil})
        recompute-grid-sizes! (fn []
                                (js/setTimeout
                                 (partial vu/recompute-grid-sizes-with-state! grid-store)
                                 0))]
    (fn [_args]
      (let [screening-profiles (:sorted-grid-entities @db/screening-profiles)
            selected-screening-profiles (:selected @db/screening-profiles)
            filters @db/screening-profile-filters

            grid-atom (create-props-atom selected-screening-profiles
                                         screening-profiles
                                         filters
                                         grid-store
                                         recompute-grid-sizes!
                                         hover-atom
                                         modal-atom)

            selected-screening-profile-id
            @(rf/subscribe [::grid-subs/selected-screening-profile])

            tenant-schema @session/tenant-schema
            show-quick-filters? (:show-quick-filters? @db/screening-profiles)
            setup-args @(r/track events/setup-args)

            filters-props {:minimized?            (not show-quick-filters?)
                           :hide-maximize?        true
                           :universal-search?     true
                           :search-placeholder    (loc/tr :search-for-a-screening-profile)
                           :setup-args            (events/setup-args)
                           :set-universal-search! (r/partial grid/set-universal-search! setup-args)
                           :set-name-search!      (r/partial grid/set-name-search! setup-args)
                           :hide-named-views?     true
                           :named-views           (events/named-views)
                           :current-view          @db/view-settings
                           :columns               (events/resolve-column-keys)
                           :all-columns           (events/resolve-column-key-universe)
                           :get-column-label      (fn [a]
                                                    (attribute/attribute-label tenant-schema a))
                           :set-filter!           (fn [k filter-data]
                                                    (grid/set-filter (events/setup-args) k filter-data))
                           :edit-filter!          (fn [k filter-data]
                                                    (grid/open-filter-curtain
                                                     {:field-key      k
                                                      :field-schema   (registry/get-field-schema tenant-schema
                                                                                                 k)
                                                      :options        (->>
                                                                       (events/resolve-column-key-universe)
                                                                       (map (juxt identity
                                                                                  (partial
                                                                                   registry/get-field-schema
                                                                                   tenant-schema))))
                                                      :current-filter filter-data
                                                      :update-fn!     (fn [k filter-data]
                                                                        (grid/set-filter (events/setup-args)
                                                                                         k
                                                                                         filter-data))}
                                                     nil))
                           :hide-qf-attributes    [:common/created-by :common/updated-by
                                                   :screening-profile/kyc-profiles
                                                   :screening-profile/person-profile
                                                   :screening-profile/screening-service]
                           :load-view!            (fn [named-view]
                                                    (events/load-view! named-view)
                                                    (grid/clear-selection! {:state db/screening-profiles}))
                           :save-view!            (fn [] nil)
                           :delete-view!          named-view-events/delete-view!
                           :toggle-minimize!      (fn []
                                                    (events/toggle-quick-filters!)
                                                    (.setTimeout js/window recompute-grid-sizes! 1000))}

            hiccup
            [:<>
             [grid-filters/view
              filters-props]
             [:div
              {:class "flex flex-auto ps-4"}
              [:div
               {:class-name (fu/cs "grid-view-content" "named-views-minimized")}
               (when selected-screening-profile-id
                 [new-modal
                  {:hide!    #(rf/dispatch [::events/close-modal])
                   :selected selected-screening-profile-id}])

               [scrollable-grid/view
                {:props-atom grid-atom
                 :hover-atom hover-atom}]]]]]
        hiccup))))

(defn toolbar
  [_args]
  (let [view-mode :grid-mode]
    [:div
     {:class "px-4 py-1 flex items-center justify-between
                   bg-base-light
                   border-b border-solid border-base-light-border-paler"}
     [:div
      {:class "w-full flex justify-between gap-6"}
      [:div
       [:div
        {:class "flex gap-2 items-center"}
        [:div
         {:class "flex items-center gap-1"}
         [:label
          {:class "font-semibold"}
          (loc/tr :screening-profiles)]
         [:span
          {:class "h-5 px-2 flex items-center justify-center text-xs font-semibold text-base-light-text bg-complement-regular rounded-full"}
          (count @db/sorted-kanban-entities)]]

        [grid-components/named-view-selector
         {:named-views               (events/named-views)
          :current-view              @db/view-settings
          :load-view!                (fn [id]
                                       (events/load-view! (events/named-view-by-id id))
                                       (grid/clear-selection! {:state db/screening-profiles}))
          :delete-view!              (fn [] nil)
          :accounts-with-view-access (session/active-accounts-with-module-access :module/screening)
          :saving-disabled?          true}]]]

      [:div
       {:class "flex justify-content-end items-center gap-2"}
       [:div
        (zap-toolbar/dropdown (->> (toolbar-actions {:view-mode view-mode})
                                   (filter :dropdown-action?)
                                   (remove (fn [{:keys [hidden?]}]
                                             (when (fn? hidden?)
                                               (hidden?))))
                                   (sort-by :ord))
                              true)]]]]))

(defn view
  [_args _kanban-feature?]
  (let [grid-store (atom {})
        close-atom (atom false)]

    (r/create-class
     {:component-did-mount    (fn []
                                (fu/timeout 10 (partial events/setup close-atom)))
      :component-will-unmount (fn []
                                (reset! close-atom true)
                                (events/cleanup))
      :reagent-render         (partial render grid-store)})))

(defmethod routing/render-view :screening-old
  [{:keys []}]
  (if (or (session/is-read-only-user?)
          (not (session/screening?)))
    [not-found/not-found-view]
    [default-page-layout/view
     [:<>
      [components/card-settings-toolbar
       [toolbar {:view-mode :grid-mode}] db/kanban]
      [view]]]))
